import React from 'react';
import styles from './Logo.module.css';

const Logo = () => {
  return (
    <div className={styles.logoContainer}>
      <img src="/img/icons/EmberAnvilLogo.png" alt="Ember & Anvil Logo" className={styles.logoImage} />
      {/* Text removed */}
    </div>
  );
};

export default Logo;